// @ts-nocheck
/* eslint-disable react/prop-types */
import { Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  InputLabel,
  Modal,
  OutlinedInput,
  Tab,
  Tabs,
  Typography,
  CircularProgress,
  useMediaQuery,
  Checkbox,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import Star from "../../../assets/images/star.svg";
import DoneIcon from "@mui/icons-material/Done";
import { apiRequest } from "../../../services/apiService";
import {
  assignClientAction,
  fetchNewEventAction,
} from "../../../store/actions/eventRequest";
import { alertDialogAciton } from "../../../store/actions/auth";
import { addLogAction } from "../../../store/actions/logs";
import {
  phoneNumberForApi,
  phoneNumberFormat,
} from "../../../utils/methods/formatters";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import styles from "../../contract-details/contractDetails.module.css";
import { ClientApproveModal } from "../../../components/Layout/_components/CLientApproveModal";
import {
  fetchEventDetailsAction,
  fetchLogsAction,
} from "../../../store/actions/eventRequestDetails";
import { rowsPerPageInit } from "../../../utils/constants/paginationConstants";
import {
  CLIENT_EMAIL,
  CLIENT_EMAIL_LABEL,
} from "../../../utils/constants/client";
import {
  CustomChip,
  SmallAddButton,
} from "../../../components/Custom/CustomIconButton";
import { CustomTooltip } from "../../../components/Tooltip/ClientTool";
import AddClientModal, {
  titleSx,
} from "../../user-clients/components/AddClientModal";
import AddressAutocomplete from "../../../components/Custom/react-google-maps/AddressAutoComplete";
import {
  compareKeys,
  formatAddress,
} from "../../../utils/methods/other/otherUtils";
import CompaniesAutocompelte from "../../../components/Custom/CompaniesAutocompelte";
import MergeClientBilling from "../../user-clients/components/MergeClientBilling";
import UnderlineButton from "../../../components/Custom/UnderlineButton";
import { AddInvoiceEamils } from "../../user-clients/components/AddInvoiceEmails";
import { alpha, fontSize } from "@mui/system";
import { addBillingInfoToEventAction } from "../../../store/actions/client";
import { isUserRole, isActiveRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import InfoHover from "../../../components/Tooltip/InfoHover";
import _ from "lodash";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  maxHeight: "95vh",
  overflowY: "auto",
};

const allProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export default function AssignClientModal({
  open,
  setOpen,
  eventInfo,
  refreshNewEventRequest,
  isList = false,
  setConInfo = () => {},
}) {
  const addInvoiceInit = useMemo(() => {
    return {
      status: false,
      type: CLIENT_EMAIL.estimate,
    };
  }, []);
  const dispatch = useDispatch();
  const { userId, userRole } = useSelector((state) => state.auth);
  // NOTE: do NOT gate the Assign button on `state.eventRequest.isLoading`.
  // That flag is the shared event-LIST loading state and starts as `true`
  // (initialState). When this modal is opened from a context that never
  // fetched that list (e.g. "Assign a client first" during estimate
  // generation), `isLoading` stays `true`, so the button rendered a permanent
  // spinner AND the onClick guard `if (isLoading) return` bailed out before
  // firing any request. We track the assign request locally instead.
  const [assignLoading, setAssignLoading] = useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [fetchedClients, setFetchedClients] = React.useState([]);
  const [searchClientText, setSearchClientText] = React.useState("");
  const [selectedClient, setSelectedClient] = React.useState(null);
  const [selectedClientForEdit, setSelectedClientForEdit] = useState(null);
  const [selectedClientDetials, setSelectedClientDetails] = useState({});
  const [createClientInfo, setCreateClientInfo] = React.useState({
    isLoading: false,
    isError: false,
    error: null,
  });
  const [showApproveModal, setShowApproveModal] = React.useState(false);
  const [addInvoice, setAddInvoice] = useState(addInvoiceInit);
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [addBillingToEvent, setAddBillingToEvent] = useState(false);
  const [editClientModal, setEditClientModal] = useState(false);
  const [showSearchBusiness, setShowSearchBusiness] = useState(false);
  const [sendEmail, setSendEmail] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  React.useEffect(() => {
    const debouncedFunction = _.debounce(() => {
      fetchClients(searchClientText);
    }, 400);

    debouncedFunction();

    return () => {
      debouncedFunction.cancel();
    };
  }, [searchClientText]);

  React.useEffect(() => {
    if (eventInfo?.contactInfo) {
      const data = eventInfo?.contactInfo;
      // console.log(">> contact", data);
      formik.setValues({
        firstName: eventInfo?.contactInfo?.firstName,
        lastName: eventInfo?.contactInfo?.lastName,
        mobile: phoneNumberFormat(eventInfo?.contactInfo?.mobile),
        email: eventInfo?.contactInfo?.email,
        companyName:
          eventInfo?.contactInfo?.company ||
          data?.clientDetails?.companyName ||
          "",
        isBusinessProfile: data?.isBusinessProfile || false,
        existingBusinessProfileId: null,
        isSameAddress: data?.clientDetails?.isSameAddress || true,
        companyAddress: data?.clientDetails?.companyAddress,
        COIAddress: data?.clientDetails?.COIAddress,
        emails: {
          estimateEmails:
            data?.clientDetails?.emails?.estimateEmails?.map((e) => ({
              ...e,
              estimateMobile: phoneNumberFormat(e?.estimateMobile),
            })) || [],
          invoiceEmails:
            data?.clientDetails?.emails?.invoiceEmails?.map((e) => ({
              ...e,
              invoiceMobile: phoneNumberFormat(e?.invoiceMobile),
            })) || [],
          depositInvoiceEmails:
            data?.clientDetails?.emails?.depositInvoiceEmails?.map((e) => ({
              ...e,
              depositInvoiceMobile: phoneNumberFormat(e?.depositInvoiceMobile),
            })) || [],
        },
      });
    } else {
      if (isList || !eventInfo?.contactInformationId) return;
      // contactInformationId may arrive as a populated object or a raw id;
      // normalize to the string id so the URL is not "/[object Object]".
      const contactInfoId =
        eventInfo?.contactInformationId?._id ||
        eventInfo?.contactInformationId;
      fetchContactInformation(contactInfoId);
    }
  }, [eventInfo]);

  useEffect(() => {
    if (selectedClient) {
      setSelectedClientDetails({});
      setSelectedClient(null);
    }
  }, [searchClientText]);

  const handleClose = () => {
    setOpen(false);
    setFetchedClients([]);
    setSearchClientText("");
  };

  const handleModalClose = () => {
    setOpen(false);
    setFetchedClients([]);
    setSearchClientText("");
  };

  async function fetchContactInformation(id) {
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getContactInformation/${id}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      formik.setValues({
        firstName: response?.data?.data?.firstName,
        lastName: response?.data?.data?.lastName,
        mobile: phoneNumberFormat(response?.data?.data?.mobile),
        email: response?.data?.data?.email,
        companyName: response?.data?.data?.company,
      });
      setConInfo(response?.data?.data);
    } else if (response?.status !== 200 || error) {}
  }

  async function fetchClients(text) {
    setSearchLoading(true);
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getActiveClients?search=${text}`,
      data: null,
      isToken: true,
      params: {
        limit: 15,
        page: 1,
      },
    });

    if (response?.status === 200) {
      setFetchedClients(response?.data?.data);
      setSearchLoading(false);
    } else if (response?.status !== 200 || error) {
      setSearchLoading(false);
      console.error("Unable to fetch clients");
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const failedToSetClient = () => {
    setAssignLoading(false);
    refreshNewEventRequest();
    handleClose();
  };

  const setClientForEvent = (clientId) => {
    setAssignLoading(true);
    dispatch(
      assignClientAction(
        {
          eventId: eventInfo?.eventId || eventInfo?._id,
          data: {
            userId: clientId ? clientId : selectedClient,
            sentEmailToClientOnAssign: sendEmail,
          },
        },
        () => {
          setAssignLoading(false);
          if (!isList) {
            dispatch(
              fetchEventDetailsAction({
                eventId: eventInfo?.eventId || eventInfo?._id,
              }),
            );
            dispatch(
              fetchLogsAction({
                eventId: eventInfo?.eventId || eventInfo?._id,
              }),
            );
          }
          refreshNewEventRequest();
          dispatch(
            addLogAction({
              id: eventInfo?.eventId || eventInfo?._id,
              payload: {
                actionById: userId,
                description: `Client has been assigned for this event.`,
                userId: clientId,
              },
            }),
          );
          handleClose();
        },
        failedToSetClient,
      ),
    );
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    isBusinessProfile: false,
    existingBusinessProfileId: null,
    companyName: "",
    isSameAddress: true,
    companyAddress: "",
    COIAddress: "",
    emails: {
      estimateEmails: [],
      invoiceEmails: [],
      depositInvoiceEmails: [],
    },
  };

  const emailSchema = (type) => {
    const emailName = `${type}Email`;
    const mobileName = `${type}Mobile`;
    return Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .trim()
          .max(200, "Name should have at most 200 characters"),
        [emailName]: Yup.string()
          .trim()
          .email("Invalid email")
          .required("Email required"),
        [mobileName]: Yup.string()
          .matches(/^\d{3}-\d{3}-\d{4}$/, { message: "Phone number must be of 10 digit", excludeEmptyString: true }),
      }),
    );
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .max(100, "First Name should have at most 100 characters!")
      .required("First name is required"),
    lastName: Yup.string()
      .trim()
      .max(100, "Last Name should have at most 100 characters")
      .required("Last name is required"),
    mobile: Yup.string()
      .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone number must be of 10 digit")
      .required("Phone number is required"),
    email: Yup.string()
      .trim()
      .email("Invalid email")
      .required("Email is required"),
    companyName: Yup.string()
      .trim()
      .max(255, "Company Name should have at most 255 characters!")
      .required("Company name is required"),
    isBusinessProfile: Yup.boolean(),
    companyAddress: Yup.string()
      .trim()
      .optional()
      .max(300, "Company address should have at most 300 character"),
    isSameAddress: Yup.boolean(),
    existingBusinessProfileId: Yup.string()
      .nullable()
      .when("isBusinessProfile", {
        is: false,
        then: (schema) => {
          schema.optional().nullable().notRequired();
        },
        otherwise: (schema) => schema.nullable().notRequired(),
      }),
    COIAddress: Yup.string()
      .trim()
      .optional()
      .max(300, "COI address should have at most 300 characters"),
    emails: Yup.object()
      .shape({
        estimateEmails: emailSchema(CLIENT_EMAIL.estimate),
        invoiceEmails: emailSchema(CLIENT_EMAIL.invoice),
        depositInvoiceEmails: emailSchema(CLIENT_EMAIL.depositInvoice),
      })
      .optional(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const payload = {
        ...values,
        mobile: phoneNumberForApi(values?.mobile),
        email: values?.email?.trim()?.toLowerCase(),
        eventId: eventInfo?.eventId || eventInfo?._id,
        sentEmailToClientOnSignup: sendEmail,
        clientDetails: {
          emails: {
            depositInvoiceEmails: values?.emails?.depositInvoiceEmails?.map(
              (e) => ({
                ...e,
                depositInvoiceMobile: phoneNumberForApi(
                  e?.depositInvoiceMobile,
                ),
              }),
            ),
            invoiceEmails: values?.emails?.invoiceEmails?.map((e) => ({
              ...e,
              invoiceMobile: phoneNumberForApi(e?.invoiceMobile),
            })),
            estimateEmails: values?.emails?.estimateEmails?.map((e) => ({
              ...e,
              estimateMobile: phoneNumberForApi(e?.estimateMobile),
            })),
          },
          companyAddress: values?.companyAddress,
          COIAddress: values?.COIAddress,
        },
        forceAdd: false,
        createdBy: userId,
      };

      async function addClient(force) {
        // do the api call here to add new client
        setCreateClientInfo({ isLoading: true, isError: false, error: null });
        if (force) {
          payload.forceAdd = force;
        }
        const newPayload = payload;
        if (addBillingToEvent) {
          delete newPayload.clientDetails;
          delete newPayload.isSameAddress;
          delete newPayload.COIAddress;
          delete newPayload.companyAddress;
          delete newPayload.emails;
        }
        const { response, error } = await apiRequest({
          method: "POST",
          url: "addClient",
          data: newPayload,
          isToken: true,
        });
        if (response?.status === 200) {
          setCreateClientInfo({
            isLoading: false,
            isError: false,
            error: null,
          });
          setClientForEvent(response?.data?.data?._id);
          if (addBillingToEvent) {
            dispatch(
              addBillingInfoToEventAction({
                payload: {
                  data: {
                    billingData: {
                      companyName: values?.companyName,
                      companyAddress: values?.companyAddress,
                      isSameAddress: values?.isSameAddress,
                      COIAddress: values?.COIAddress,
                      emails: {
                        depositInvoiceEmails:
                          values?.emails?.depositInvoiceEmails?.map((e) => ({
                            ...e,
                            depositInvoiceMobile: phoneNumberForApi(
                              e?.depositInvoiceMobile,
                            ),
                          })),
                        invoiceEmails: values?.emails?.invoiceEmails?.map(
                          (e) => ({
                            ...e,
                            invoiceMobile: phoneNumberForApi(e?.invoiceMobile),
                          }),
                        ),
                        estimateEmails: values?.emails?.estimateEmails?.map(
                          (e) => ({
                            ...e,
                            estimateMobile: phoneNumberForApi(
                              e?.estimateMobile,
                            ),
                          }),
                        ),
                      },
                    },
                  },
                  params: {
                    eventId: eventInfo?.eventId || eventInfo?._id,
                  },
                },
              }),
            );
          }
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: "Client has been assigned for this event.",
            }),
          );
        } else if (response?.status !== 200 || error) {
          if (error?.response?.data?.canForceAdd) {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Warning",
                message:
                  error?.response?.data?.message ||
                  "We have a similar company available.",
                okLabel: "Add Anyway",
                onOk: () => {
                  addClient(true);
                },
              }),
            );
            setCreateClientInfo({
              isLoading: false,
              isError: true,
              error: "unable to create client",
            });
            return;
          }
          setCreateClientInfo({
            isLoading: false,
            isError: true,
            error: "unable to create client",
          });
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message:
                error?.response?.data?.message || "Unable to create client",
            }),
          );
        }
      }

      addClient();
    },
  });

  const {
    values,
    setValues,
    touched,
    handleBlur,
    handleChange,
    errors,
    handleSubmit,
    setFieldValue,
  } = formik;

  const titleSx = {
    fontSize: "1rem",
    color: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
  };

  const isValuesSameWithExistingClient = useMemo(() => {
    if (!selectedClient || !eventInfo?.contactInfo) return true;

    const isClientDetailsSame = compareKeys({
      obj1: eventInfo?.contactInfo,
      key1: "clientDetails",
      obj2: selectedClientDetials,
      key2: "clientDetails",
    });
    const isBothHaveSameAddress =
      eventInfo?.contactInfo?.isSameAddress ==
      selectedClientDetials?.isSameAddress;

    return isClientDetailsSame && isBothHaveSameAddress;
  }, [selectedClientDetials, selectedClient, eventInfo?.contactInfo]);

  const providedDataValues = useMemo(() => {
    return {
      firstName: eventInfo?.contactInfo?.firstName,
      lastName: eventInfo?.contactInfo?.lastName,
      mobile: phoneNumberFormat(eventInfo?.contactInfo?.mobile),
      email: eventInfo?.contactInfo?.email,
      companyName:
        eventInfo?.contactInfo?.company ||
        eventInfo?.contactInfo?.clientDetails?.companyName ||
        "",
      isBusinessProfile: eventInfo?.contactInfo?.isBusinessProfile || false,
      existingBusinessProfileId: null,
      isSameAddress:
        eventInfo?.contactInfo?.clientDetails?.isSameAddress || true,
      companyAddress: eventInfo?.contactInfo?.clientDetails?.companyAddress,
      COIAddress: eventInfo?.contactInfo?.clientDetails?.COIAddress,
      emails: {
        estimateEmails:
          eventInfo?.contactInfo?.clientDetails?.emails?.estimateEmails?.map(
            (e) => ({
              ...e,
              estimateMobile: phoneNumberFormat(e?.estimateMobile),
            }),
          ) || [],
        invoiceEmails:
          eventInfo?.contactInfo?.clientDetails?.emails?.invoiceEmails?.map(
            (e) => ({
              ...e,
              invoiceMobile: phoneNumberFormat(e?.invoiceMobile),
            }),
          ) || [],
        depositInvoiceEmails:
          eventInfo?.contactInfo?.clientDetails?.emails?.depositInvoiceEmails?.map(
            (e) => ({
              ...e,
              depositInvoiceMobile: phoneNumberFormat(e?.depositInvoiceMobile),
            }),
          ) || [],
      },
    };
  }, [eventInfo]);

  const showSearch = useMemo(() => {
    if (values?.isBusinessProfile) {
      return showSearchBusiness;
    } else {
      return true;
    }
  }, [showSearchBusiness, values?.isBusinessProfile]);

  React.useEffect(() => {
    if (createClientInfo.isError) {
      const interval = setTimeout(() => {
        setCreateClientInfo({ isLoading: false, isError: false, error: null });
      }, 3000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [createClientInfo.isError]);

  const handleMobileChange = (event) => {
    const input = event.target.value;
    const formattedInput = input
      .replace(/\D/g, "")
      .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
        let formattedNumber = "";
        if (p1) {
          formattedNumber += p1;
        }
        if (p2) {
          formattedNumber += "-" + p2;
        }
        if (p3) {
          formattedNumber += "-" + p3;
        }
        return formattedNumber;
      });
    handleChange({
      target: {
        name: "mobile",
        value: formattedInput,
      },
    });
  };
  const handleAssignClick = () => {
    const client = fetchedClients.find((c) => c._id === selectedClient);

    if (!client) return;

    if (!client.isApproved) {
      // Show modal if not approved
      setShowApproveModal(true);
    } else {
      // Proceed with assign logic
      // yourAssignFunction(client);
    }
  };

  function handleBusinessTabChange(_, newValue) {
    setFieldValue("isBusinessProfile", newValue == 0 ? true : false);
    setFieldValue("existingBusinessProfileId", null);
  }

  function setCOIAddress(address) {
    if (values?.existingBusinessProfileId && !values?.isBusinessProfile) return;
    setFieldValue("COIAddress", formatAddress(address));
  }
  function setCompanyAddress(address) {
    if (values?.existingBusinessProfileId && !values?.isBusinessProfile) return;
    setFieldValue("companyAddress", formatAddress(address));
  }

  function addInvoiceAppendFunc({ values, type }) {
    if (type == "all") {
      const estimateEmails = `${CLIENT_EMAIL.estimate}Emails`;
      const depositInvoiceEmails = `${CLIENT_EMAIL.depositInvoice}Emails`;
      const invoiceEmails = `${CLIENT_EMAIL.invoice}Emails`;
      setValues((prev) => ({
        ...prev,
        emails: {
          ...prev?.emails,
          estimateEmails: [
            ...(prev?.emails?.[estimateEmails] || []),
            {
              estimateEmail: values?.allEmail,
              estimateMobile: values?.allMobile,
              name: values?.name,
            },
          ],
          [depositInvoiceEmails]: [
            ...(prev?.emails?.[depositInvoiceEmails] || []),
            {
              depositInvoiceEmail: values?.allEmail,
              depositInvoiceMobile: values?.allMobile,
              name: values?.name,
            },
          ],
          [invoiceEmails]: [
            ...(prev?.emails?.[invoiceEmails] || []),
            {
              invoiceEmail: values?.allEmail,
              invoiceMobile: values?.allMobile,
              name: values?.name,
            },
          ],
        },
      }));
      return;
    }
    const key = `${type}Emails`;
    setValues((prev) => ({
      ...prev,
      emails: {
        ...prev?.emails,
        [key]: [...(prev?.emails?.[key] || []), values],
      },
    }));
  }
  return (
    <Modal
      className="modelBox"
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          ...style,
          "@media (max-width: 600px)": {
            width: "97vw",
            minWidth: "96vw",
            maxHeight: "95vh",
            overflowY: "auto",
          },
        }}
        className="custom-scroll-design"
      >
        <Typography
          className="model-title"
          id="modal-modal-title"
          variant="h6"
          component="h2"
          marginBottom="20px"
        >
          Assign Client
        </Typography>
        <Box sx={{ width: "100%", marginBottom: "30px" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            TabScrollButtonProps={{
              style: {
                color: `${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
              },
            }}
            aria-label="basic tabs example"
            variant="scrollable"
            sx={{
              width: "100%",
              border: "1px solid #D175B6",
              overflow: "hidden",
              display: "inline-flex",
              justifyContent: "space-between",
              borderRadius: "8px",
              "& button": {
                textTransform: "none",
                width: "50%",
                color: "#D175B6",
                "&.Mui-selected": {
                  backgroundColor: "#D175B6",
                },
                "& span": {
                  display: "none",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab label="Assign An Existing Client" {...allProps(0)} />
            <Tab label="Add New Client" {...allProps(1)} />
          </Tabs>
        </Box>
        {tabValue === 0 && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <OutlinedInput
                placeholder="Type here to search client"
                value={searchClientText}
                onChange={(e) => setSearchClientText(e.target.value)}
                inputProps={{
                  "aria-label": "weight",
                }}
                style={{
                  width: "100%",
                  color: "#fff",
                  height: "50px",
                  border: "1px solid #D175B6",
                  borderRadius: "10px",
                }}
                sx={{
                  "& fieldset": {
                    borderColor: "#D175B6 !important",
                    borderRadius: "10px",
                  },
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <Search sx={{ color: "white" }} />
                  </InputAdornment>
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                opacity: fetchedClients?.length > 0 ? 1 : 0,
              }}
            >
              <Box
                className="custom-scroll-design"
                sx={{
                  position: "relative",
                  border: "1px solid #D175B6",
                  borderRadius: "10px",
                  minHeight: "280px",
                  maxHeight: "280px",
                  overflowY: "auto",
                  padding: "10px",
                }}
              >
                {selectedClient && selectedClientDetials?._id && false ? (
                  <Box
                    sx={{
                      padding: "0.5rem 1rem",
                    }}
                  >
                    <Typography sx={{ fontSize: "1.15rem", fontWeight: "500" }}>
                      Selected Client{" "}
                    </Typography>
                    <Typography
                      className={styles["key-val-container"]}
                      sx={{
                        paddingTop: "0.5rem",
                      }}
                    >
                      <Typography
                        className={styles["key-title"]}
                        sx={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        }}
                      >
                        Client Name:
                      </Typography>
                      <Typography className={`${styles["key-details"]}`}>
                        {`${selectedClientDetials?.firstName} ${selectedClientDetials?.lastName}`}
                      </Typography>
                    </Typography>
                    <Typography>
                      <span
                        style={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        }}
                      >
                        Phone:{" "}
                      </span>{" "}
                      {phoneNumberFormat(selectedClientDetials?.mobile)}{" "}
                      <span
                        style={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                          paddingLeft: "0.5rem",
                        }}
                      >
                        Email:
                      </span>{" "}
                      {selectedClientDetials?.email}
                    </Typography>
                    <Typography className={styles["key-val-container"]}>
                      <Typography
                        className={styles["key-title"]}
                        sx={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        }}
                      >
                        Company Name:
                      </Typography>
                      <Typography className={`${styles["key-details"]}`}>
                        {selectedClientDetials?.companyName}
                      </Typography>
                    </Typography>

                    <Box
                      sx={{
                        width: "100%",
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={() => {
                          setSelectedClient(null);
                          setSelectedClientDetails({});
                        }}
                      >
                        Choose Another Client
                      </Button>
                    </Box>
                  </Box>
                ) : searchLoading ? (
                  <LoadingOverlay open />
                ) : (
                  fetchedClients?.map((client) => (
                    <Box
                      key={client?._id}
                      sx={{
                        position: "relative",
                        border: "1px solid #D175B6",
                        borderRadius: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                        paddingX: "10px",
                        paddingY: "5px",
                        backgroundColor:
                          selectedClient === client?._id
                            ? "rgba(209, 117, 182, 0.4)"
                            : "",
                        "&:hover": {
                          backgroundColor: "rgba(209, 117, 182, 0.4)",
                          // "& h6": {
                          //   color: "#000",
                          // },
                          // "& p": {
                          //   color: "#000",
                          // },
                        },
                      }}
                      onClick={() => {
                        setSelectedClientDetails(client);
                        setSelectedClient(client?._id);
                      }}
                    >
                      <Typography
                        color="primary"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        {client?.firstName} {client?.lastName}
                        <img
                          style={{ marginLeft: "10px" }}
                          src={Star}
                          alt="star"
                        />
                        <Typography
                          color="secondary"
                          sx={{
                            display: "inline",
                            paddingLeft: "10px",
                          }}
                        >
                          {client?.companyName}
                        </Typography>
                      </Typography>
                      <Typography color="secondary">
                        <span style={{ color: "white" }}>Phone: </span>{" "}
                        {phoneNumberFormat(client?.mobile)} -{" "}
                        <span style={{ color: "white" }}>Email:</span>{" "}
                        {client?.email}
                      </Typography>
                      {selectedClient === client?._id && (
                        <DoneIcon
                          fontSize="medium"
                          style={{
                            color: "#D175B6",
                            position: "absolute",
                            right: "10px",
                            top: "25%",
                          }}
                        />
                      )}
                    </Box>
                  ))
                )}
              </Box>
              {!isValuesSameWithExistingClient && (
                <Box sx={{ p: 1 }}>
                  <Typography>
                    We've noticed the billing details of selected client and
                    provided with contact information is different. If you wish
                    to update billing details of selected client, click{" "}
                    <Typography
                      component={"span"}
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setEditClientModal(true);
                        setSelectedClientForEdit(selectedClientDetials);
                      }}
                      className="email-link"
                    >
                      here
                    </Typography>
                    . Or you can continue with assigning client.
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        )}
        {tabValue === 1 && (
          <>
            {/* <Box */}
            {/*   sx={{ */}
            {/*     width: "100%", */}
            {/*     mb: 2, */}
            {/*     px: 4, */}
            {/*     // display: values?.isBusinessProfile ? "inherit" : "none", */}
            {/*   }} */}
            {/* > */}
            {/*   <Tabs */}
            {/*     value={values?.isBusinessProfile ? 0 : 1} */}
            {/*     onChange={handleBusinessTabChange} */}
            {/*     TabScrollButtonProps={{ */}
            {/*       style: { */}
            {/*         color: `${getCssVariableHandler({ */}
            {/*           variableName: "--primary-pink-hex", */}
            {/*         })}`, */}
            {/*       }, */}
            {/*     }} */}
            {/*     aria-label="basic tabs example" */}
            {/*     variant="scrollable" */}
            {/*     sx={{ */}
            {/*       width: "100%", */}
            {/*       border: "1px solid #D175B6", */}
            {/*       overflow: "hidden", */}
            {/*       display: "inline-flex", */}
            {/*       justifyContent: "space-between", */}
            {/*       borderRadius: "8px", */}
            {/*       minHeight: "36px", */}
            {/*       height: "36px", */}
            {/*       "& button": { */}
            {/*         textTransform: "none", */}
            {/*         padding: "0px", // Reset padding */}
            {/*         minHeight: "36px", */}
            {/*         height: "36px", */}
            {/*         width: "50%", */}
            {/*         color: "#D175B6", */}
            {/*         display: "flex", */}
            {/*         alignItems: "center", // Center content vertically */}
            {/*         justifyContent: "center", // Center content horizontally */}
            {/*         lineHeight: "1", // Reset line height for better control */}
            {/*         "&.Mui-selected": { */}
            {/*           backgroundColor: "#D175B6", */}
            {/*         }, */}
            {/*         "& span": { */}
            {/*           display: "none", */}
            {/*         }, */}
            {/*       }, */}
            {/*       "& .MuiTabs-indicator": { */}
            {/*         display: "none", */}
            {/*       }, */}
            {/*       "& .MuiButtonBase-root": { */}
            {/*         height: "36px", */}
            {/*       }, */}
            {/*       "& .MuiTab-root": { */}
            {/*         padding: "0 16px", // Add horizontal padding only */}
            {/*         minHeight: "36px", */}
            {/*       }, */}
            {/*     }} */}
            {/*   > */}
            {/*     <Tab label="Business Profile" id={0} /> */}
            {/*     <Tab label="Representative Profile" id={1} /> */}
            {/*   </Tabs> */}
            {/* </Box> */}
            <Box
              sx={{
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
                borderRadius: "0.5rem",
                p: 2,
                mb: 2,
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography sx={titleSx}>Personal Details:</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box className="new-form-box">
                    <InputLabel>First Name</InputLabel>
                    <input
                      name="firstName"
                      value={values.firstName}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="First Name"
                    />
                    {errors.firstName && touched.firstName && (
                      <Typography variant="subtitle2" color="red">
                        {errors.firstName}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box className="new-form-box">
                    <InputLabel>Last Name</InputLabel>
                    <input
                      name="lastName"
                      value={values.lastName}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Last Name"
                    />
                    {errors.lastName && touched.lastName && (
                      <Typography variant="subtitle2" color="red">
                        {errors.lastName}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box className="new-form-box">
                    <InputLabel>Phone Number</InputLabel>
                    <input
                      name="mobile"
                      value={values.mobile}
                      onBlur={handleBlur}
                      onChange={handleMobileChange}
                      placeholder="XXX-XXX-XXXX"
                    />
                    {errors.mobile && touched.mobile && (
                      <Typography variant="subtitle2" color="red">
                        {errors.mobile}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box className="new-form-box">
                    <InputLabel>Email</InputLabel>
                    <input
                      name="email"
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="abc@xyz.com"
                    />
                    {errors.email && touched.email && (
                      <Typography variant="subtitle2" color="red">
                        {errors.email}
                      </Typography>
                    )}
                  </Box>
                </Grid>

                {!isActiveRole(USER_ROLES.CLIENT) && (
                  <Grid item xs={12}>
                    <InputLabel>Profile Type</InputLabel>
                    <FormControl
                      sx={{
                        width: "100%",
                      }}
                    >
                      <RadioGroup
                        name="profileType"
                        row
                        sx={{
                          flexWrap: "wrap",
                        }}
                        value={values?.isBusinessProfile ? 0 : 1}
                        onChange={(e) => {
                          const value = e?.target?.value;
                          if (value == 0) {
                            setFieldValue("isBusinessProfile", true);
                          } else {
                            setFieldValue("isBusinessProfile", false);
                          }
                        }} // your handler
                      >
                        <FormControlLabel
                          value="0"
                          control={
                            <Radio
                              sx={{
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                                "&.Mui-checked": {
                                  color: getCssVariableHandler({
                                    variableName: "--primary-pink-hex",
                                  }),
                                },
                              }}
                            />
                          }
                          label={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.3rem",
                              }}
                            >
                              Primary Contact
                              {/* NOTE: update the info icon with black i and white bg */}
                              <InfoHover
                                title="Please select this profile, if you are primary contact of your comany or identifies yourself  as a business owner or you are an individual."
                                infoStyles={{
                                  color: getCssVariableHandler({
                                    variableName: "--white-rgb",
                                  }),
                                }}
                                isBgFilled
                              />
                            </Box>
                          }
                        />
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              sx={{
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                                "&.Mui-checked": {
                                  color: getCssVariableHandler({
                                    variableName: "--primary-pink-hex",
                                  }),
                                },
                              }}
                            />
                          }
                          label={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.3rem",
                              }}
                            >
                              Representative Profile
                              <InfoHover
                                title="This profile identifies you as a representative of a registered business."
                                infoStyles={{
                                  color: getCssVariableHandler({
                                    variableName: "--white-rgb",
                                  }),
                                }}
                                isBgFilled
                              />
                            </Box>
                          }
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Box>
            <Box
              sx={{
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
                borderRadius: "0.5rem",
                p: 2,
                mb: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography sx={titleSx}>Company Details:</Typography>
                </Grid>
                {values?.isBusinessProfile && (
                  <Grid item xs={12} sx={{ paddingTop: "2px !important" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showSearchBusiness}
                          sx={{
                            color: "white",
                          }}
                          onChange={(e) => {
                            const val = e.target.checked;
                            setShowSearchBusiness(val);
                            if (!val) {
                              setFieldValue("existingBusinessProfileId", null);
                              setFieldValue("companyName", "");
                              setFieldValue("companyAddress", "");
                              setFieldValue("COIAddress", "");
                              setFieldValue("isSameAddress", true);
                              setFieldValue("emails", {
                                depositInvoiceEmails: [],
                                estimateEmails: [],
                                invoiceEmails: [],
                              });
                            }
                          }}
                        />
                      }
                      label="Select Existing Company"
                      sx={{
                        margin: 0,
                        "& .MuiFormControlLabel-label": {},
                      }}
                    />
                  </Grid>
                )}
                {showSearch && (
                  <Grid item xs={12}>
                    <Box className="new-form-box">
                      <InputLabel>Select Company</InputLabel>
                      <CompaniesAutocompelte
                        placeholder={"Search Companies"}
                        noOptionsText={"No Companies Found"}
                        // value={values?.existingBusinessProfileId}
                        name={"existingBusinessProfileId"}
                        onBlur={handleBlur}
                        fetchOptions={true}
                        getOptionLabel={(op) => op?.companyName || ""}
                        borderColor={"#6d6c6c"}
                        onChange={(_, newVal) => {
                          // Mesmo autofill do AddClientModal — ver comentário lá.
                          const sameAddress = newVal?.isSameAddress ?? true;
                          const companyAddress =
                            newVal?.clientDetails?.companyAddress ?? "";
                          setFieldValue(
                            "companyName",
                            newVal?.companyName ?? "",
                          );
                          setFieldValue("isSameAddress", sameAddress);
                          setFieldValue("companyAddress", companyAddress);
                          setFieldValue(
                            "COIAddress",
                            sameAddress
                              ? companyAddress
                              : (newVal?.clientDetails?.COIAddress ?? ""),
                          );
                          const emails = {
                            depositInvoiceEmails:
                              newVal?.clientDetails?.emails?.depositInvoiceEmails?.map(
                                (i) => ({
                                  ...i,
                                  depositInvoiceMobile: phoneNumberFormat(
                                    i?.depositInvoiceMobile,
                                  ),
                                }),
                              ),
                            estimateEmails:
                              newVal?.clientDetails?.emails?.estimateEmails?.map(
                                (i) => ({
                                  ...i,
                                  estimateMobile: phoneNumberFormat(
                                    i?.estimateMobile,
                                  ),
                                }),
                              ),
                            invoiceEmails:
                              newVal?.clientDetails?.emails?.invoiceEmails?.map(
                                (i) => ({
                                  ...i,
                                  invoiceMobile: phoneNumberFormat(
                                    i?.invoiceMobile,
                                  ),
                                }),
                              ),
                          };
                          setFieldValue("emails", emails);
                          setFieldValue(
                            "existingBusinessProfileId",
                            newVal?._id,
                          );
                        }}
                      />
                      {errors.existingBusinessProfileId &&
                        touched.existingBusinessProfileId && (
                          <Typography variant="subtitle2" color="red">
                            {errors.existingBusinessProfileId}
                          </Typography>
                        )}
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box className="new-form-box">
                    <Grid
                      item
                      xs={12}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <InputLabel>Company Name</InputLabel>
                      <UnderlineButton
                        title={"Compare Billing Information"}
                        onClick={() => setShowMergeModal(true)}
                        styles={{
                          fontSize: "1rem",
                        }}
                      />
                    </Grid>
                    <input
                      name="companyName"
                      value={values.companyName}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Company Name"
                    />
                    {errors.companyName && touched.companyName && (
                      <Typography variant="subtitle2" color="red">
                        {errors.companyName}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className="new-form-box">
                    <InputLabel>Company Address</InputLabel>
                    <AddressAutocomplete
                      setAddress={setCompanyAddress}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      value={values.companyAddress}
                      fullWidth
                      placeholder="Type company address"
                      name="companyAddress"
                      onChange={handleChange}
                    />

                    {errors.companyAddress && touched.companyAddress && (
                      <Typography variant="subtitle2" color="red">
                        {errors.companyAddress}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <Checkbox
                        name={"isSameAddress"}
                        checked={values?.isSameAddress || false}
                        onChange={(e) => {
                          if (
                            !values?.isBusinessProfile &&
                            values?.existingBusinessProfileId
                          )
                            return;
                          setValues((values) => {
                            return {
                              ...values,
                              isSameAddress: e?.target?.checked,
                            };
                          });
                        }}
                        onBlur={handleBlur}
                        sx={{
                          color: getCssVariableHandler({
                            variableName: "--font-rgb",
                          }),
                          padding: "0",
                        }}
                      />
                      <InputLabel
                        sx={{
                          marginBottom: "0 !important",
                        }}
                      >
                        Use same address for COI as company Address
                      </InputLabel>
                    </Box>
                  </Box>
                </Grid>

                {!values?.isSameAddress && (
                  <Grid item xs={12}>
                    <Box className="new-form-box">
                      <InputLabel>COI Address</InputLabel>

                      <AddressAutocomplete setAddress={setCOIAddress}>
                        <input
                          name="COIAddress"
                          value={values.COIAddress}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          placeholder="Type COI Address"
                        />
                      </AddressAutocomplete>
                      {errors.COIAddress && touched.COIAddress && (
                        <Typography variant="subtitle2" color="red">
                          {errors.COIAddress}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            <Box
              sx={{
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
                borderRadius: "0.5rem",
                p: 2,
                mb: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography sx={{ ...titleSx, display: "inline" }}>
                    Billing Informations:
                  </Typography>
                  <SmallAddButton
                    onClick={() => {
                      setAddInvoice({ status: true, type: "all" });
                    }}
                    title={"Add to all"}
                  />
                </Grid>

                <div style={{ paddingLeft: "1rem", paddingTop: "1rem" }}>
                  {addInvoice?.status && addInvoice?.type == "all" ? (
                    <AddInvoiceEamils
                      open={addInvoice?.status}
                      handleClose={() => setAddInvoice(addInvoiceInit)}
                      type={"all"}
                      addEmail={addInvoiceAppendFunc}
                    />
                  ) : null}
                </div>
                {[
                  CLIENT_EMAIL.estimate,
                  CLIENT_EMAIL.depositInvoice,
                  CLIENT_EMAIL.invoice,
                ]?.map((item) => {
                  const key = `${item}Emails`;
                  return (
                    <Grid item xs={12} key={item}>
                      <Typography
                        sx={{
                          ...titleSx,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          color: getCssVariableHandler({
                            variableName: "--white-rgb",
                          }),
                          paddingBottom: 1,
                        }}
                      >
                        {CLIENT_EMAIL_LABEL?.[item]} Profiles:
                        <SmallAddButton
                          onClick={() => {
                            setAddInvoice({ status: true, type: item });
                          }}
                        />
                      </Typography>
                      {addInvoice?.status && addInvoice?.type == item ? (
                        <AddInvoiceEamils
                          open={addInvoice?.status}
                          handleClose={() => setAddInvoice(addInvoiceInit)}
                          type={addInvoice?.type}
                          addEmail={addInvoiceAppendFunc}
                        />
                      ) : null}
                      {values?.emails?.[key]?.length == 0 ? (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography
                            sx={{
                              border: `1px solid ${getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              })}`,
                              borderRadius: "0.5rem",
                              px: 2,
                              py: "2px",
                              mb: 1,
                              mx: "auto",
                              backgroundColor: alpha("#fff", 0.2),
                            }}
                            component={"span"}
                            textAlign={"center"}
                          >
                            No {CLIENT_EMAIL_LABEL?.[item]} Profile Added
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            gap: "0.5rem",
                            flexWrap: "wrap",
                          }}
                        >
                          {values?.emails?.[key]?.map((e, i) => {
                            return (
                              <CustomChip
                                key={i}
                                label={
                                  <CustomTooltip
                                    title={
                                      <Box
                                        key={i}
                                        sx={{
                                          border: `1px solid ${getCssVariableHandler(
                                            {
                                              variableName:
                                                "--primary-pink-hex",
                                            },
                                          )}`,
                                          borderRadius: "0.5rem",
                                          p: 1,
                                          mb: 1,
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            gap: isSmallScreen ? "0" : "1rem",
                                            width: "100%",
                                            flexWrap: "wrap",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "flex-start",
                                              gap: isSmallScreen
                                                ? "0.25rem"
                                                : "0.5rem",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                color: getCssVariableHandler({
                                                  variableName:
                                                    "--primary-pink-hex",
                                                }),
                                                fontWeight: "500",
                                              }}
                                            >
                                              Name:{" "}
                                            </Typography>
                                            <Typography>{e?.name || e?.[`${item}Email`]}</Typography>
                                          </Typography>
                                        </Box>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            gap: isSmallScreen ? "0" : "1rem",
                                            width: "100%",
                                            flexWrap: "wrap",
                                            flexDirection: isSmallScreen
                                              ? "column"
                                              : "row",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "flex-start",
                                              gap: isSmallScreen
                                                ? "0.25rem"
                                                : "0.5rem",
                                              width: "100%",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                color: getCssVariableHandler({
                                                  variableName:
                                                    "--primary-pink-hex",
                                                }),
                                                fontWeight: "500",
                                              }}
                                            >
                                              Phone:{" "}
                                            </Typography>
                                            <Typography>
                                              {phoneNumberFormat(
                                                e?.[`${item}Mobile`],
                                              )}
                                            </Typography>
                                          </Typography>
                                        </Box>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            gap: isSmallScreen ? "0" : "1rem",
                                            width: "100%",
                                            flexWrap: "wrap",
                                            flexDirection: isSmallScreen
                                              ? "column"
                                              : "row",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "flex-start",
                                              gap: isSmallScreen
                                                ? "0.25rem"
                                                : "0.5rem",
                                              width: isSmallScreen
                                                ? "100%"
                                                : "47%",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                color: getCssVariableHandler({
                                                  variableName:
                                                    "--primary-pink-hex",
                                                }),
                                                fontWeight: "500",
                                              }}
                                            >
                                              Email:{" "}
                                            </Typography>
                                            <Typography>
                                              {e?.[`${item}Email`]}{" "}
                                            </Typography>
                                          </Typography>
                                        </Box>
                                      </Box>
                                    }
                                  >
                                    {e?.name || e?.[`${item}Email`]}
                                  </CustomTooltip>
                                }
                                onDelete={() => {
                                  setValues((prev) => ({
                                    ...prev,
                                    emails: {
                                      ...prev.emails,
                                      [`${item}Emails`]: prev.emails[
                                        `${item}Emails`
                                      ].filter((_, index) => index !== i),
                                    },
                                  }));
                                }}
                              />
                            );
                          })}
                        </Box>
                      )}
                    </Grid>
                  );
                })}
              </Grid>

              {/* {tabValue == 1 && ( */}
              {/*   <Grid sx={{ mt: 2 }} item xs={12}> */}
              {/*     <Box */}
              {/*       sx={{ */}
              {/*         display: "flex", */}
              {/*         alignItems: "center", */}
              {/*         justifyContent: "flex-start", */}
              {/*         gap: "10px", */}
              {/*       }} */}
              {/*     > */}
              {/*       <Checkbox */}
              {/*         name={"isSameAddress"} */}
              {/*         checked={addBillingToEvent} */}
              {/*         onChange={() => { */}
              {/*           setAddBillingToEvent(!addBillingToEvent); */}
              {/*         }} */}
              {/*         sx={{ */}
              {/*           color: getCssVariableHandler({ */}
              {/*             variableName: "--font-rgb", */}
              {/*           }), */}
              {/*           padding: "0", */}
              {/*         }} */}
              {/*       /> */}
              {/*       <Typography */}
              {/*         sx={{ */}
              {/*           marginBottom: "0 !important", */}
              {/*         }} */}
              {/*       > */}
              {/*         Attach billing details to the event only, without */}
              {/*         modifying the client’s billing information. */}
              {/*       </Typography> */}
              {/*     </Box> */}
              {/*   </Grid> */}
              {/* )} */}
            </Box>
          </>
        )}

        {/* {tabValue == 1 && ( */}
        {/*   <Typography sx={{ mt: 2 }} textAlign={"center"}> */}
        {/*     NOTE: With edit of company and billing details it'll also edit for */}
        {/*     the clients with same company. */}
        {/*   </Typography> */}
        {/* )} */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.5rem",
            width: "100%",
            mt: 3,
          }}
        >
          <Checkbox
            name="sendemail"
            sx={{
              cursor: "pointer",
              padding: "0",
              color: getCssVariableHandler({
                variableName: "--white-rgb",
              }),
              "&.Mui-checked": {
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
                "& svg": {
                  fill: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                },
              },
            }}
            checked={!!sendEmail}
            onChange={(e) => {
              setSendEmail(e?.target?.checked);
            }}
          />
          <Typography>
            Send an email to client informing account creation
          </Typography>
        </Box>

        <Box className="bottom-btn-box">
          <Button
            className="btn-black"
            onClick={() => {
              // formik.setValues(initialValues);
              // handleClose();
              handleModalClose();
            }}
          >
            <Typography className="btn-text">CLOSE</Typography>
          </Button>
          <Button
            sx={{
              cursor:
                assignLoading || createClientInfo.isLoading
                  ? "not-allowed"
                  : "pointer",
            }}
            disableRipple={assignLoading || createClientInfo.isLoading}
            className="btn-pink"
            onClick={() => {
              if (assignLoading || createClientInfo.isLoading) return;
              if (tabValue === 0) {
                const client = fetchedClients.find(
                  (c) => c._id === selectedClient,
                );

                if (!client) return;

                if (!client.isApproved) {
                  setShowApproveModal(true);
                } else {
                  setClientForEvent();
                }
              } else if (tabValue === 1) {
                handleSubmit();
              }
            }}
          >
            {assignLoading || createClientInfo.isLoading ? (
              <CircularProgress />
            ) : (
              <Typography className="btn-text no-wrap">
                {tabValue === 0 ? "Assign" : "Add Client"}
              </Typography>
            )}
          </Button>
        </Box>
        {showApproveModal && (
          <ClientApproveModal
            open={showApproveModal}
            onClose={() => setShowApproveModal(false)}
            row={selectedClientDetials}
            isAssign
            onApproved={(id) => {
              setShowApproveModal(false);
              setClientForEvent(id);
              handleClose();
            }}
          />
        )}

        <MergeClientBilling
          open={showMergeModal}
          onClose={() => {
            setShowMergeModal(false);
          }}
          providedData={values}
          companyData={values}
          formik={formik}
          onSaveClick={() => {}}
        />

        {editClientModal && (
          <AddClientModal
            open={editClientModal}
            setOpen={setEditClientModal}
            data={selectedClientForEdit}
            setEditingData={setSelectedClientForEdit}
            heading={"Edit Client"}
            afterSaveCall={() => {
              // handleClose();
              setSearchClientText(searchClientText);
            }}
            providedDataValue={providedDataValues}
          />
        )}
      </Box>
    </Modal>
  );
}